import { produce } from 'immer';

import { UpdateInternalMarketersFilterParams } from '../../../actions/marketers/internal/updateInternalMarketersFilterParams';
import { MarketersState } from '../../../typings/marketers';

export function updateInternalMarketersFilterParams(
    state: MarketersState,
    action: UpdateInternalMarketersFilterParams
): MarketersState {
    return produce(state, draft => {
        draft.filter = action.params;
    });
}
